import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Scheme } from 'modules/overlay-canvas/types';
import { PreviewState } from 'modules/template-editor/domain/interface/preview-state';

export interface EditorSliceState {
  activeModal?: string;
  previewState?: PreviewState;

  hasChanges: boolean;
  savedScheme?: Scheme;

  isInit: boolean;
  isEditingText: boolean;
}

const initialState: EditorSliceState = {
  hasChanges: false,
  isInit: false,
  isEditingText: false,
};

export const editorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setHasChanges: (state, action: PayloadAction<boolean>) => {
      state.hasChanges = action.payload;
    },
    setSavedScheme: (state, action: PayloadAction<Scheme | undefined>) => {
      state.savedScheme = action.payload as any;
    },
    setPreviewState: (state, action: PayloadAction<PreviewState | undefined>) => {
      state.previewState = action.payload as any;
    },
    setActiveModal: (state, action: PayloadAction<string | undefined>) => {
      state.activeModal = action.payload;
    },
    setInit: (state, action: PayloadAction<boolean>) => {
      state.isInit = action.payload;
    },
    setIsEditingText: (state, action: PayloadAction<boolean>) => {
      state.isEditingText = action.payload;
    },
  },
});

export const { setHasChanges, setSavedScheme, setActiveModal, setPreviewState, setInit, setIsEditingText } = editorSlice.actions;

export default editorSlice.reducer;
